export default "__VITE_ASSET__99faa487__"